import { Box, Tooltip, useTheme } from "@mui/material";
import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface CustomProps {
  infoMessage: any;
  placement?:
    | "top"
    | "right"
    | "bottom"
    | "left"
    | "bottom-end"
    | "bottom-start"
    | "left-end"
    | "left-start"
    | "right-end"
    | "right-start"
    | "top-end"
    | "top-start";
  children?: any;
}

const CustomInfoTooltip = (props: CustomProps) => {
  const theme = useTheme();
  return (
    <Tooltip
      title={props?.infoMessage ?? ""}
      placement={props.placement ? props.placement : "bottom"}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            width: "auto",
            background: theme.palette.primary.dark,
            fontSize: "12px",
            fontFamily: "Inter, sans-serif",
          },
        },
        arrow: {
          sx: {
            "&::before": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
      }}
      sx={{ cursor: "pointer !important" }}
    >
      {props.children ? (
        props.children
      ) : (
        <InfoOutlinedIcon
          fontSize="small"
          sx={{ color: theme.palette.primary.main }}
        />
      )}
    </Tooltip>
  );
};

export default CustomInfoTooltip;
